import { render, staticRenderFns } from "./MisTickets.vue?vue&type=template&id=08168f8d"
import script from "./MisTickets.vue?vue&type=script&lang=js"
export * from "./MisTickets.vue?vue&type=script&lang=js"
import style0 from "./MisTickets.vue?vue&type=style&index=0&id=08168f8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
